// Maps raw entity-type labels emitted by the discovery model to clean display
// names for the UI. Keys must match the labels the model actually emits (see the
// emitted-entity catalog in c2-discover-model); anything not listed falls back to
// title-casing the raw label. Display only — never used as a lookup key for
// algorithm resolution (see Secure/Utils.js maskingAlgorithmFromEntityMap, which
// keys off the raw label).
const UILabelMap = {
    ACCOUNT_NUMBER: 'Account Number',
    ADDRESS_LINE2: 'Address Line 2',
    ADDRESS_STREET: 'Street Address',
    AUTH_SECRET: 'Auth Secret (MFA/API)',
    BIRTH_DATE: 'Birth Date',
    CANADIAN_SIN: 'Canadian SIN',
    CA_HEALTH_NUMBER: 'CA Health Number',
    CITY: 'City',
    CLOUD_ACCESS_KEY: 'Cloud Access Key',
    CONNECTION_STRING: 'Connection String Credentials',
    COUNTRY: 'Country',
    COUNTY: 'County',
    CREDIT_CARD: 'Credit Card',
    DEATH_DATE: 'Death Date',
    DIAGNOSIS: 'Diagnosis',
    DRIVING_LC: 'Drivers License',
    DRUG: 'Drug',
    EMAIL: 'Email',
    FIRST_NAME: 'First Name',
    IMMUNIZATION: 'Immunization',
    INSURANCE: 'Insurance',
    INSURANCE_PLAN_ID: 'Insurance Plan ID',
    IP_ADDRESS: 'IP Address',
    JWT_TOKEN: 'JWT Token',
    KEY_MATERIAL_FILE: 'Key Material File',
    LAST_NAME: 'Last Name',
    LATITUDE: 'Latitude',
    LOCATION: 'Location',
    LONGITUDE: 'Longitude',
    MEMBER_ID: 'Member ID',
    MEDICARE_BENEFICIARY_IDENTIFIER_MBI: 'Medicare Beneficiary ID (MBI)',
    MEDICARE_BENEFICIARY_IDENTIFIER_HICN: 'Medicare HICN',
    MEDICARE_BENEFICIARY_IDENTIFIER: 'Medicare Beneficiary ID', // legacy pre-split label
    MEDI_CAL_CIN: 'Medi-Cal CIN',
    NPI: 'NPI',
    ORG: 'Organization',
    PASSPORT: 'Passport',
    PASSWORD: 'Password',
    PATIENT_DATE: 'Patient Date',
    PATIENT_ID: 'Patient ID',
    PERSON: 'Person',
    PO_BOX: 'PO Box',
    PRIVATE_KEY: 'Private Key',
    SSN: 'SSN',
    STATE: 'State',
    SUFFIX: 'Suffix',
    TELEPHONE_NO: 'Telephone',
    UUID: 'UUID',
    VENDOR_API_KEY: 'Vendor API Key',
    WEB: 'Web URL',
    ZIP: 'ZIP Code',
    // Synthetic / aggregate labels surfaced by the reports UI (not model entities)
    LOW_INCIDENCE_FINDINGS: 'Low Incidence',
};

// Returns a clean display name for a raw entity label. Unknown labels are
// title-cased (UNDERSCORE_CASE -> "Underscore Case"). Pure function — does not
// mutate UILabelMap.
const uiLabel = (label) => {
    if (label == null) return '';
    const mapped = UILabelMap[label];
    if (mapped) return mapped;

    return String(label)
        .toLowerCase()
        .replaceAll('_', ' ')
        .split(' ')
        .map((s) => (s ? s.charAt(0).toUpperCase() + s.substring(1) : s))
        .join(' ');
};

// Known entity codes (the model-emitted labels this UI has display names for), excluding
// synthetic/aggregate labels that aren't real entities. Used by the Advanced Settings config
// screens to enumerate configurable entities. Not exhaustive of everything the model can emit —
// unknown codes still render via uiLabel()'s title-case fallback.
const KNOWN_ENTITY_CODES = Object.keys(UILabelMap).filter(
    (code) => code !== 'LOW_INCIDENCE_FINDINGS',
);

export {
    uiLabel,
    KNOWN_ENTITY_CODES,
};
